/**
 * Strips tracking parameters from the address bar. Two waves, each timed to its
 * parameter:
 *  - `_psid`-family ride-alongs, `shpxid` and the market's `country`: right
 *    away, this file being deferred, so the head analytics has already read
 *    them. The market rides on the `localization` cookie.
 *  - Google Shopping arrival params (`srsltid`, `_pos`/`_psq`): after load and
 *    idle, because late pixels still read the landing URL.
 *
 * Only the parameters listed here: UTM tags, filters, sort and page survive.
 */
(function () {
  var IMMEDIATE = ['_psid', '_pos', '_sid', '_ss', '_fd', '_ptid', 'shpxid', 'country'];
  var DEFERRED = ['_pos', '_psq', '_ss', '_v', 'srsltid'];

  function strip(liste) {
    try {
      if (!window.history || !history.replaceState || !window.URL) return;
      var url = new URL(location.href);
      var touche = false;
      for (var i = 0; i < liste.length; i++) {
        if (url.searchParams.has(liste[i])) {
          url.searchParams.delete(liste[i]);
          touche = true;
        }
      }
      if (!touche) return;
      history.replaceState(history.state, '', url.pathname + url.search + url.hash);
    } catch (e) {
      /* an unusable URL is not worth breaking the page for */
    }
  }

  strip(IMMEDIATE);

  function later() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(function () { strip(DEFERRED); }, { timeout: 2500 });
    } else {
      setTimeout(function () { strip(DEFERRED); }, 1500);
    }
  }
  if (document.readyState === 'complete') later();
  else window.addEventListener('load', later, { once: true });
})();
